export const COOKIE_STORAGE_KEY = "stackularCookieConsent";

export const COOKIE_CONSENT = {
  ACCEPTED: "accepted",
  REJECTED: "rejected",
} as const;

export const COOKIE_EVENTS = {
  OPEN_SETTINGS: "open-cookie-settings",
  CONSENT_CHANGED: "cookie-consent-changed",
} as const;